import { SearchStock, type SearchStockProps } from "fin-web-components";
import { observer } from "mobx-react-lite";
import { useEffect, useMemo } from "react";
import { globalModel } from "../../global/GlobalModel";

export type SearchStockWithCatalogProps = Omit<SearchStockProps, "stocksCatalog"> & {
  /** 清空输入（叉或删至空）时回调；依赖 fin-web-components SearchStock 的 `onCleared`（已合入 main 后生效） */
  onCleared?: () => void;
};

/** 注入 longfans GlobalModel 股票清单，并与 MobX 联动刷新 */
export const SearchStockWithCatalog = observer(function SearchStockWithCatalog(
  props: SearchStockWithCatalogProps
) {
  const { enableHK = false, enableUS = false } = props;

  useEffect(() => {
    if (enableHK || enableUS) {
      void globalModel.loadOverseasStocksCatalog();
    }
  }, [enableHK, enableUS]);

  const stocksCatalog = useMemo(() => {
    if (!enableHK && !enableUS) {
      return globalModel.basicStocksCatalog;
    }
    return [...globalModel.basicStocksCatalog, ...globalModel.overseasStocksCatalog];
  }, [
    enableHK,
    enableUS,
    globalModel.basicStocksCatalog,
    globalModel.overseasStocksCatalog,
  ]);

  return (
    <SearchStock
      {...(props as SearchStockProps)}
      stocksCatalog={stocksCatalog}
    />
  );
});
